module.exports = __webpack_public_path__ + "media/images/estado-financiero-4cb53b31eb235d48d0a801a9702c15d2.svg";